<template>
    <div>
        <game-detail :details='details'></game-detail>
    </div>
</template>

<script>
import gameDetail from '../../components/gamedetail/gamedetail'

import logo_img from '../../images/xianlaigame/xianlai_zbgj.png'
import ercodeimg from '../../images/gamecenter_ercode/ercode_zbgj.png'
import list_img1 from '../../images/download/down_zbgj1.png'
import list_img2 from '../../images/download/down_zbgj2.png'
import list_img3 from '../../images/download/down_zbgj3.png'
export default {
    data() {
        return {
            details: {
                logo_img: logo_img,
                name: '闲徕主播管家',
                size: '32.88',
                load_count: '50',
                desp: '闲徕主播管家是一款专门为签约主播和试播主播群体使用的辅助工具；实时分析直播数据，随时查看收入业绩；提供多种登陆方式，提供拉新码和兑换码、扣币补玉功能，助力主播直播效果，提升主播收益。',
                ios_url: 'http://app3.xvwqfh.cn/?downloadfrom=zhuboguanjia',
                android_url: 'http://app3.xvwqfh.cn/?downloadfrom=zhuboguanjia',
                ercodeimg: ercodeimg,
                list_img1: list_img1,
                list_img2: list_img2,
                list_img3: list_img3,
                cut_img1: ''
            }
        }
    },
    components: {
        gameDetail
    }
}
</script>

<style scoped>
</style>
